<template>
  <div data-test="newBattleForm" class=" pb-4">
    <battle-list :items="getUserBattles" :logged-in="loggedIn" />
    <fader animation="fadedelay">
      <div
        class="border-bg-lightest bg-tint-less border-t relative z-1"
        id="BattleAdder"
      >
        <add-field
          autofocus
          data-test="newBattleField"
          placeholder="New battle name…"
          button-title="Add battle"
          button-test="newBattleButton"
          button-classes="absolute t l-full text-accent hover:text-accent py-4"
          field-classes="px-3 py-4 border-bg-lightest border-t"
          @submit="submit"
        />
      </div>
    </fader>
  </div>
</template>

<script>
import BattleList from '@/components/BattleList'
import AddField from '@/components/AddField'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: `NewBattleForm`,

  components: {
    BattleList,
    AddField,
  },

  computed: {
    ...mapGetters(`accounts`, [`loggedIn`]),
    ...mapGetters(`battles`, [`getUserBattles`]),
  },

  methods: {
    async submit({ target }) {
      await this.create({ name: target.field.value })
      target.reset()
    },
    ...mapActions(`battles`, [`create`]),
  },
}
</script>
